'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getOne();
  }

  getOne() {
    this.$http.get(`/api/AppConfGroups/${this.$stateParams.id}`).then(res => {
      this.one = res.data;
    });
  }

  save() {
    this.$http.put(`/api/AppConfGroups/${this.$stateParams.id}`, this.one).then(res => {
      this.$state.go('^');
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/appconfgroups/edit/edit.controller.js